export default {
  common: {
    actions: "Действия",
    view: "Просмотр",
    edit: "Редактировать",
    delete: "Удалить",
    manage: "Управление",
    preview: "Предпросмотр",
    clear: "Очистить",
    confirm: "Подтвердить",
    submit: "Отправить",
    next: "Далее",
    back: "Назад",
    save: "Сохранить",
    reset: "Сбросить",
    cancel: "Отмена",
    find: "Найти",
    refresh: "Обновить",
    resend_email: "Повторно отправить письмо",
    upload: "Загрузить",
    add: "Добавить",
    prompt: "Подсказка",
    ok: "Ок",
    continue: "Продолжить",
    update: "Обновить",
    apply: "Применить",
    previous: "Предыдущий",
    type: "Тип",
    success: "Успешно",
    fail: "Ошибка",
    no_data: "Нет данных",
    start_time: "Время начала",
    end_time: "Время окончания",
    per_page: "Количество записей на странице",
    yes: "Да",
    start_date: "Дата начала",
    end_date: "Дата окончания",
    login: "Вход",
    password: "Пароль",
    email: "Электронная почта",
    welcome: "Добро пожаловать",
    search: "Поиск",
    enter: "Ввести",
    pending: "В ожидании",
    created: "Создано",
    in_query: "Выполняется поиск",

    Blue: "Синий",
    Green: "Зелёный",
    Red: "Красный",
    Yellow: "Жёлтый",
    White: "Белый",
    Pink: "Розовый",
    Cyan: "Голубой",

    device_deleted: "Устройство удалено",
    set_password: "Установить пароль",
    new_password: "Новый пароль",
    confirm_password: "Подтвердите пароль",
    common_mismatched: "Пароли не совпадают",


    query_center: "",
    no_options: "Нет вариантов",
    system_default: "Системный по умолчанию",
    personal_template: "Личный шаблон",
    otaUpdata: "Обновление OTA",
    is: "Да",
    is_not: "Нет",
    advGroup: "Группа рекламы электронных ценников",
    light_setting: "Настройки яркости",
    turn_off: "Выключить",
    device_advgroup: "Рекламная группа шлюза",

    common_form_get_code_surplus: "Повторная отправка через секунд",
    common_form_get_code: "Повторно отправить код",
    column_manager: "Управление столбцами",
    common_password_enter: "Введите новый пароль",
    common_confirm_password_enter: "Введите подтверждение пароля",
    token_expired: "Срок действия авторизации истёк. Пожалуйста, войдите снова",
    account_remote_login: "Выполнен вход в учётную запись с другого устройства. Пожалуйста, войдите заново"

  },

  dictionary: {
    vertical: "Вертикальный",
    horizontal: "Горизонтальный",
    generaluse: "Общее применение",
    discount: "Скидка",
    byunit: "По единице товара",
    by_value: "По сумме",
    promotion: "Специальная акция",
  },

  month: {
    january: "Январь",
    february: "Февраль",
    march: "Март",
    April: "Апрель",
    May: "Май",
    June: "Июнь",
    July: "Июль",
    August: "Август",
    September: "Сентябрь",
    October: "Октябрь",
    November: "Ноябрь",
    December: "Декабрь",
  },

  zoontime: {
    International: "(GMT-12:00) Международная линия перемены дат",
    Coordinated: "(UTC-11) Всемирное координированное время-11",
    Hawaii: "(UTC-10) Гавайи",
    Alaska: "(UTC-9) Аляска",
    California: "(UTC-8) Тихоокеанское время (США и Канада), Нижняя Калифорния",
    Arizona: "(UTC-7) Ла-Пас, Горное время (США и Канада), Аризона",
    America: "(UTC-6) Саскачеван, Центральное время, Центральная Америка",
    Eastern: "(UTC-5) Богота, Лима, Кито, Риу-Бранку, Восточное время, Индиана (Восток)",
    Caracas: "(UTC-4:30) Каракас",
    Atlantic: "(UTC-4) Атлантическое время, Куяба, Джорджтаун, Ла-Пас, Сантьяго",
    Newfoundland: "(UTC-3:30) Ньюфаундленд",
    Brasilia: "(UTC-3) Бразилиа, Буэнос-Айрес, Гренландия, Кайенна",
    International2: "(UTC-2) Международная линия перемены дат Запад-02",
    Azores: "(UTC-1) Острова Кабо-Верде, Азорские острова",
    Edinburgh: "(UTC) Дублин, Эдинбург, Лиссабон, Лондон, Международная линия перемены дат Запад",
    Brussels: "(UTC+1) Амстердам, Брюссель, Сараево",
    Damascus: "(UTC+2) Бейрут, Дамаск, Восточная Европа, Каир, Афины, Иерусалим",
    Kuwait: "(UTC+3) Багдад, Кувейт, Москва, Санкт-Петербург, Найроби",
    Tehran: "(UTC+3:30) Тегеран",
    Yerevan: "(UTC+4) Абу-Даби, Ереван, Баку, Порт-Луи, Самарра",
    Kabul: "(UTC+4:30) Кабул",
    Karachi: "(UTC+5) Ашхабад, Исламабад, Карачи",
    Calcutta: "(UTC+5:30) Ченнаи, Калькутта, Мумбаи, Нью-Дели",
    Kathmandu: "(UTC+5:45) Катманду",
    Novosibirsk: "(UTC+6) Астана, Дакка, Новосибирск",
    Yangon: "(UTC+6:30) Янгон",
    Jakarta: "(UTC+7) Бангкок, Ханой, Джакарта",
    Beijing: "(UTC+08:00) Пекин, Чунцин, Гонконг, Урумчи, Куала-Лумпур, Сингапур",
    Yakutsk: "(UTC+9) Осака, Токио, Сеул, Якутск",
    Adelaide: "(UTC+9:30) Аделаида, Дарвин",
    Canberra: "(UTC+10) Брисбен, Владивосток, Гуам, Канберра",
    Islands: "(UTC+11) Соломоновы Острова, Новая Каледония",
    Oakland: "(UTC+12) Анадырь, Окленд, Веллингтон, Фиджи",
    alofa: "(UTC+13) Нукуалофа, Острова Самоа",
    Island: "(UTC+14) Остров Рождества"
  },
};
